module.exports = __webpack_public_path__ + "img/demo.437bf91a.jpg";